import React, { useState } from "react";
import { useGetInvestments } from "@api/v1/hooks/useInvestments";
import { Depot } from "../stateMachine/types/depots";
import { NameAndDepotStep } from "./NameAndDepotStep";

export interface Props {
  handleNext: (depotId: number, name: string, comment?: string) => void;
  handleNewDepot: (name: string, comment?: string) => void;
  handlePrevious: () => void;
  defaultName: string;
  defaultComment?: string;
  selectedDepotId?: number;
  selectableDepots: Depot[];
  isin?: string;
}

export const NameAndDepotStepWithLookup = ({
  handleNext,
  handleNewDepot,
  handlePrevious,
  defaultName,
  defaultComment,
  selectedDepotId,
  selectableDepots,
  isin,
}: Props) => {
  const [depotId, setDepotId] = useState<number | undefined>(selectedDepotId);
  const handleDepotIdChange = (id: number) => {
    setDepotId(id);
  };

  const handleNextWrapper = (name: string, comment?: string) => {
    if (!depotId) return;
    handleNext(depotId, name, comment);
  };

  const { data: investmentList } = useGetInvestments(
    {
      accountId: depotId ? [depotId] : undefined,
      isin: isin ? [isin] : undefined,
      includeHistoric: false,
    },
    { enabled: !!depotId && !!isin }
  );

  const investment = investmentList?.investments?.length
    ? investmentList.investments[0]
    : undefined;

  return (
    <NameAndDepotStep
      handleNext={handleNextWrapper}
      handleNewDepot={handleNewDepot}
      handlePrevious={handlePrevious}
      defaultName={defaultName}
      defaultComment={defaultComment}
      selectedDepotId={depotId}
      handleDepotIdChange={handleDepotIdChange}
      selectableDepots={selectableDepots}
      existingLots={investment ? investment.numberOfLots : 0}
    />
  );
};
